module.exports = __webpack_public_path__ + "img/image-1.ab9dc94d.jpg";